import React from "react";

const OrientationDriverEvalItem: React.FC<{ description: string, status: boolean, value: number, onToggle: () => void }> = ({description, status, value, onToggle}) => {
    return (
        <div className="roadtest-question driver-eval-item">
            <div className="roadtest-question__name">{description}</div>
            <div className="driver-eval-item__row">
                <span className={`roadtest-question__value roadtest-question__value--${value < 0 ? 'negative' : 'positive'}`}>
                    {status ? 'YES' : 'NO'}{value < 0 ? ` (${value})` : ''}
                </span>
                <div className="driver-eval-item__options">
                    <button
                        type="button"
                        className={`roadtest-question__option roadtest-question__option--positive${status ? ' is-selected' : ''}`}
                        onClick={() => { if (!status) onToggle(); }}
                    >
                        YES
                    </button>
                    <button
                        type="button"
                        className={`roadtest-question__option roadtest-question__option--negative${!status ? ' is-selected' : ''}`}
                        onClick={() => { if (status) onToggle(); }}
                    >
                        NO
                    </button>
                </div>
            </div>
        </div>
    )
}

export default OrientationDriverEvalItem
